import { message } from "antd";
import { jwtDecode } from "jwt-decode";
import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import useAuthApi from "../utils/useAuthApi";

export default function useSetActiveBranch() {
  const { setActiveBranch } = useAuthApi();
  const { user, refreshUser, handleRefreshToken } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const changeActiveBranch = async (branchId) => {
    if (branchId === user?.active_branch_id) {
      return;
    }

    setIsLoading(true);

    try {
      const response = await setActiveBranch(branchId);

      const branchName =
        response.active_branch?.name ||
        user?.available_branches?.find(
          (branch) => branch.id == response.active_branch?.id
        )?.name ||
        "filial selecionada";

      // Se backend retornou tokens atualizados
      if (
        response.tokens &&
        response.tokens.access &&
        response.tokens.refresh
      ) {
        localStorage.setItem("access", response.tokens.access);
        localStorage.setItem("refresh", response.tokens.refresh);

        const decodedToken = jwtDecode(response.tokens.access);

        if (decodedToken.active_branch_id == branchId) {
          await refreshUser();
          message.success(`Filial alterada para: ${branchName}`);
          setTimeout(() => window.location.reload(), 1000);
          return response;
        }
      }

      // Fallback: refresh token
      const storedRefreshToken = localStorage.getItem("refresh");
      if (storedRefreshToken) {
        const refreshSuccess = await handleRefreshToken(storedRefreshToken);

        if (refreshSuccess) {
          await refreshUser();
          message.success(`Filial alterada para: ${branchName}`);
          setTimeout(() => window.location.reload(), 1000);
          return response;
        }
      }

      // Último recurso: reload direto
      message.success(`Filial alterada para: ${branchName}`);
      setTimeout(() => window.location.reload(), 1000);

      return response;
    } catch (error) {
      console.error("Erro ao trocar filial:", error);
      message.error("Erro ao alterar filial. Tente novamente.");
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    changeActiveBranch,
    isLoading,
  };
}
